
define( 'FORCES_AND_MOTION_BASICS/../nls/sr/forces-and-motion-basics-strings',{
          "none": "без",
          "force": "Сила",
          "values": "вредности",
          "frictionTitle": "Трење",
          "redWins": "Победили \"Црвени\" (Раднички)",
          "frictionForce": "Сила трења",
          "pause": "Пауза",
          "friction": "Трење",
          "accelerationLab": "Лабораторија за убрзање",
          "forces-and-motion-basics.name": "Силе и кретање - Основе",
          "appliedForce": "Примењена сила",
          "leftForce": "сила налево",
          "rightForce": "сила надесно",
          "acceleration": "убрзање",
          "sound": "звук",
          "lots": "много",
          "forces": "Силе",
          "motion": "Кретање",
          "tugOfWar": "Надвлачење конопца",
          "go": "Старт!",
          "newtons.n": "њутна (N)",
          "sumOfForcesEqualsZero": "збир сила  = 0",
          "blueWins": "Победили \"Плави\" (Грађански)",
          "speed": "брзина",
          "sumOfForces": "збир сила",
          "return": "Почетак",
          "translation.credits": "превео Владан Ал. Младеновић, проф.физике, Алексинац. Симулацију прво испробали Ленка и Лука",
          "newtons": "њутна",
          "masses": "масе"
        } );